import type { ClusterMatrix } from '../../data/schemas';
import { CLUSTER_IDS, type ClusterId, type QuestionId } from '../../types/ids';

/** Ermittelt je Frage den Cluster mit dem höchsten Gewicht (für Stärken-/Engpass-Zuordnung). */
export function getPrimaryClusterForQuestion(
  questionId: QuestionId,
  matrix: ClusterMatrix,
): ClusterId {
  const row = matrix.rows[questionId];
  let best: ClusterId = CLUSTER_IDS[0];
  let bestWeight = -1;
  for (const clusterId of CLUSTER_IDS) {
    const weight = row?.[clusterId] ?? 0;
    if (weight > bestWeight) {
      bestWeight = weight;
      best = clusterId;
    }
  }
  return best;
}

/** Ermittelt alle Cluster, zu denen eine Frage nennenswert beiträgt (Gewicht > 0). */
export function getRelatedClustersForQuestion(
  questionId: QuestionId,
  matrix: ClusterMatrix,
): ClusterId[] {
  const row = matrix.rows[questionId];
  return CLUSTER_IDS.filter((clusterId) => (row?.[clusterId] ?? 0) > 0);
}
